// type: Q-问题，A-答案，H-历史消息，S-停止生成，C-结束会话，T-转接会话，R-参考来源，F-点赞/点踩回执
export const MESSAGE_TYPE = {
  QUESTION: 'Q',
  ANSWER: 'A',
  HISTORY: 'H',
  STOP: 'S',
  CLOSE: 'C',
  TRANSFER: 'T',
  REFERENCE: 'R',
  FEEDBACK: 'F',
  WORKBENCH_HISTORY: 'WH'
};



// WEBPACK FOOTER //
// ./src/constants/chat.js